export const DEPOSIT_PRESETS = [1, 2, 10, 50, 100, 200, 500, 1000] as const
